import { createApi } from "@reduxjs/toolkit/query/react";
import { customFetchBase } from "../../utils/API/fetchBaseQuery";
import { transformErrorResponse, transformSuccessResponse } from "../../utils/API/responseMiddleware";

const manageStaffAPI = createApi({
    reducerPath:'manageStaffAPI',
    baseQuery:customFetchBase,
    endpoints:(builder) => ({

    
        getAllStaff: builder.query({
            query: ({plJobTypeKey,pbIncludeInactive}) => ({
                url: `/AdminManageStaff/GetAllStaff?plJobTypeKey=${plJobTypeKey}&pbIncludeInactive=${pbIncludeInactive}`,
                method: 'GET',
            }),          
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse, 
        }),

    }),
});

export const {
    useLazyGetAllStaffQuery,
 } = manageStaffAPI;

export default manageStaffAPI;